import axios, { AxiosResponse } from "axios";
import { useState } from "react";
import { useQueryClient } from "react-query";

import { useChatAuthAccessToken } from "~/ui/context";

interface MessageData {
  id: number;
  app_id: number;
  text: string;
  html: string;
  plain: string;
  created_at: string;
  created_by: {
    id: number;
    uid: string;
    display_name: string;
    username: string;
    given_name: string;
    name: string;
    family_name: string;
    nickname: string;
    avatar_url: string;
    tags: string[];
    created_at: string;
  };
}
export const useSendMessageDirect = () => {
  const accessToken = useChatAuthAccessToken();

  const [isMessageSending, setIsMessageSending] = useState(false);
  const queryClient = useQueryClient();

  async function sendMessageHandler(
    conversationId: number,
    text: string,
    cb: () => unknown
  ): Promise<MessageData> {
    try {
      setIsMessageSending(true);
      const url = `https://a079d42eaff24cbc98605bbdb08caec9.weavy.io/api/apps/${conversationId}/messages`;
      const headers = {
        Authorization: `Bearer ${accessToken}`,
      };
      const response: AxiosResponse<MessageData> = await axios.post(
        url,
        { text },
        {
          headers,
        }
      );
      await queryClient.invalidateQueries([
        "chat-conversation-messages",
        conversationId,
        accessToken,
      ]);
      return response.data;
    } catch (error) {
      setIsMessageSending(false);
      throw error;
    } finally {
      setIsMessageSending(false);
      cb();
    }
  }

  return { sendMessageHandler, isMessageSending };
};
